import RsaGestioneOspitiList from "./pages/RsaGestioneOspitiList.vue";
import RsaGestioneOspitiArchivioList from "./pages/RsaGestioneOspitiArchivioList.vue";
import RsaGestioneOspitiEdit from "./pages/RsaGestioneOspitiEdit.vue";
import RsaGestioneOspitiView from "./pages/RsaGestioneOspitiView.vue";
import RsaGestioneOspitiSchedaOspiteViewPage from "./pages/RsaGestioneOspitiSchedaOspiteViewPage.vue";
import RsaGestioneRefertiListPage from "./pages/RsaGestioneRefertiListPage.vue";
import RsaPaiEditPage from "./pages/RsaPaiEditPage.vue";
import RsaGestioneAssistitiPage from "./pages/RsaGestioneAssistitiPage.vue";
import RsaRiepilogoAccessiAdiListPage from "./pages/RsaRiepilogoAccessiAdiListPage.vue";
import RsaPazienteRiepilogoOperatoriListPage from "./pages/RsaPazienteRiepilogoOperatoriListPage.vue";
import RsaGestioneOspitiParametriVitaliListPage from "./pages/RsaGestioneOspitiParametriVitaliListPage.vue";

/*ADI*/
import RsaSchedaPazientePage from "./pages/RsaSchedaPazientePage.vue";

export default {
	RsaGestioneOspitiList,
	RsaGestioneOspitiArchivioList,
	RsaGestioneOspitiEdit,
	RsaGestioneOspitiView,
	RsaGestioneOspitiSchedaOspiteViewPage,
	RsaGestioneRefertiListPage,
	RsaPaiEditPage,
	RsaSchedaPazientePage,
	RsaGestioneAssistitiPage,
	RsaRiepilogoAccessiAdiListPage,
	RsaPazienteRiepilogoOperatoriListPage,
	RsaGestioneOspitiParametriVitaliListPage
};
